This program has been developed by students from the bachelor Computer Science
at Utrecht University within the Software Project course. Copyright (c) Utrecht
University (Department of Information and Computing Sciences)

<template>
  <div
    v-if="getUserInfo().permissionLevel !== 'student'"
    class="lessonPackagesPage"
  >
    <div class="pageContainer lg:grid-cols-10 md:grid-cols-7">
      <section class="lg:col-span-3 md:col-span-7">
        <ActiveBundles
          ref="activeBundle"
          @updateBundle="updateBundle"
          :activeBundle="activeBundle"
          @bundleRemoved="bundleRemoved"
        />
      </section>
      <section class="col-span-4">
        <ChosenLevels
          ref="chosenLevels"
          :bundleSelected="bundleSelected"
          @removePublishedLevel="removePublishedLevel"
          @updateMyBundles="updateMyBundles"
        />
      </section>
      <section class="col-span-1">
        <div class="switchItems">
          <img src="@/assets/images/icons/Switch.svg" alt="Switch items icon" />
        </div>
      </section>
      <section class="col-span-2">
        <PublishedLevels
          @usePublishedLevel="usePublishedLevel"
          ref="publishedLevels"
          :levels="levels"
        />
      </section>
    </div>
  </div>
  <QuestionButton :wikiSubjects="this.wikiSubjects" />
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import ActiveBundles from "@/components/lessonPackages/ActiveBundlesBlock.vue";
import PublishedLevels from "@/components/lessonPackages/PublishedLevelsBlock.vue";
import ChosenLevels from "@/components/lessonPackages/ChosenLevelsBlock.vue";
import { bundleLevelSettings, bundle } from "@/utils/Types";
import { getUserInfo } from "@/utils/Functions";
import QuestionButton from "@/components/QuestionButton.vue";

@Options({
  mounted() {
    this.updateQuestionButton();
  },

  components: {
    ChosenLevels,
    ActiveBundles,
    PublishedLevels,
    QuestionButton,
  },
  data() {
    return {
      activeBundle: null,
      levels: null,
      wikiSubjects: [],
    };
  },
  methods: {
    //Reset active level when bundle is deleted
    bundleRemoved() {
      this.$refs.chosenLevels.active = null;
    },
    //Update active bundle when new bundle is selected
    updateMyBundles() {
      this.$refs.activeBundle.updateMyBundles();
    },
    /**
     * Add a published level to the bundle
     * @param variable Bundle level settings
     */
    usePublishedLevel(variable: bundleLevelSettings) {
      this.$refs.chosenLevels.addLevel(variable, this.activeBundle);
    },
    /**
     * Remove published level from bundle
     * @param variable Bundle level settings
     */
    removePublishedLevel(variable: bundleLevelSettings) {
      this.$refs.publishedLevels.removePublishedLevel(variable);
    },
    /**
     * Update current bundle
     * @param b Bundle
     */
    async updateBundle(b: bundle) {
      this.activeBundle = b;
      this.$refs.chosenLevels.activeName = b.name;
      this.$refs.chosenLevels.AllCodeClicked = false;
      this.$refs.chosenLevels.AllPsdClicked = false;
      await this.$refs.chosenLevels.updateBundleLevels(b).then(async () => {
        this.levels = this.$refs.chosenLevels.levels;
        await this.$refs.publishedLevels.updatePublishedLevels(this.levels);
      });
    },
    updateQuestionButton() {
      this.wikiSubjects.push(
        {
          wikiButton: { name: this.$t("wiki.packWiki"), item: "packWikiPage" },
        }
        //here you can add more page references
      );
    },
    getUserInfo,
  },
  computed: {
    /**
     * Determine if a bundle is selected
     * @returns Bool if selected
     */
    bundleSelected() {
      return this.activeBundle != null;
    },
  },
})
export default class LessonPackages extends Vue {}
</script>

<style lang="scss">
@import "src/assets/stylesheets/pages/Packages.scss";
</style>
